import React, { useEffect, useState } from 'react';
import PaginatedDataGrid from '../../../../../common/components/Table/PaginatedDataGrid';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import { Box, Input, MenuItem, Select } from '@mui/material';
import { v4 } from "uuid";
import { CustomDataGrid } from '../../../../../common/components/Table/CustomDataGrid';
import HomePageTimeDatePicker from '../../HomePageTimeDatePicker';
import ContainedButton from '../../../../../common/components/Buttons/ContainedButton';
import httpCommon from '../../../../../http-common';
import { FileUploaderRipik } from '../../FileUploaderRipik';
import SnackbarWithMessage from '../../../../../common/components/Snackbars/SnackbarWithMessage';
import { useDispatch } from 'react-redux';
import { load_intm_backlog_from_backend } from '../../../../../redux/po_backlog/backlog.action';
import { sample_types as old_sample_types } from '../../PoTable/helper/po_columns';
import { get_material_types_list } from '../../../../Output/utils/helpers';

const BacklogFieldCell = ({ value, id, handle_change, type = "text", options = [] }) => {
  if (type === "select") {
    return <Box className="w-full">
      <Select sx={{ width: "100%" }} value={value} id={id} onChange={handle_change} name={id} >
        <MenuItem value="" disabled key={"nothing"}>Select Material Type</MenuItem>
        {
          options?.map((item, idx) => <MenuItem key={`${item.label}-${idx}`} value={item?.value} >{item?.label}</MenuItem>)
        }
      </Select>
    </Box>;
  }
  return <Input
    // sx={{ width: "100%" }}
    value={value}
    id={id}
    name={id}
    onChange={(e) => {
      handle_change(e);
    }}
    onKeyDown={(e) => {
      e.stopPropagation();
    }}
    type={type} />;
};

const postSampleStatus = async (sample_status_data) => {
  console.log(sample_status_data);
  const dd = sample_status_data.qc_receive_date.getDate();
  const mm = sample_status_data.qc_receive_date.getMonth();
  const yyyy = sample_status_data.qc_receive_date.getFullYear();
  const hh = sample_status_data.qc_receive_date.getHours();
  const min = sample_status_data.qc_receive_date.getMinutes();
  const ss = sample_status_data.qc_receive_date.getSeconds();

  const d = `${yyyy}-${mm + 1}-${dd} ${hh}:${min}:${ss}`;
  sample_status_data.qc_receive_date = d;
  delete sample_status_data.id;
  // return {
  //   status: "success"
  // };
  const data = JSON.stringify({ ...sample_status_data });
  try {
    const response = await httpCommon.post(`/v1/qc/backlog_po/`, data);
    const result = response.data;
    if (result?.status === "success") return true;
    else throw new Error(`${result.message}`);
  } catch (error) {
    console.log({ error });
    return error;
    // return ;
  }
};

const BacklogTable = ({ table_data, columns, category = "CB", hidden_fields = [] }) => {

  const [options, set_options] = useState([...old_sample_types]);

  const initialise_sample_types = async () => {
    const names_list = await get_material_types_list();
    if (names_list) {
      const sample_types_arr = names_list?.map((name) => ({
        value: name,
        label: name,
      }));
      set_options(sample_types_arr);
    }
  };

  useEffect(() => {
    initialise_sample_types();
  }, []);

  // const options = (() => {
  //   switch (category) {
  //     case "CB": {
  //       return [
  //         {
  //           label: 'CB(urgent)',
  //           value: 'CB(urgent)'
  //         },
  //         {
  //           label: 'CB',
  //           value: 'CB'
  //         },
  //         {
  //           label: 'CB(additional)',
  //           value: 'CB(additional)'
  //         }
  //       ];
  //     }
  //     case "FP": {
  //       return [
  //         { label: "FP(with micro)", value: "FP(with micro)" },
  //         { label: "FP(without micro)", value: "FP(without micro)" },
  //       ];
  //     }
  //     case "INTM": {
  //       return [
  //         { label: "SFG(without micro)", value: "SFG(without micro)" },
  //       ];
  //     }
  //     default:
  //       return [];
  //   }
  // })();

  const apiRef = useGridApiRef();

  const getRowClassName = (params) => {
    if (!params.row.within_target) {
      return 'bg-red-200 hover:bg-red-300'; // Apply this class for completed rows
    }
    return '';
  };

  const [new_dg_row, set_new_dg_row] = useState([{
    "id": v4(),
    "material_type": "",
    "product_id": "",
    "product_name": "",
    "batch_number": "",
    "qc_receive_date": new Date(),
    "market": "",
    "spec_id": "",
    "stp_id": ""
  }]);


  const handle_change_new_row_data = (e) => {
    const { id, value, name } = e.target;
    // console.log({ id, value, e, name });
    const old = { ...new_dg_row[0] };
    old[id || name] = value;
    set_new_dg_row([{ ...old }]);
  };

  const new_dg_columns = [
    {
      "field": "material_type",
      headerName: "Material Type",
      // flex: 1,
      width: 150,
      editable: true,
      align: "center",
      headerAlign: "center",
      type: "singleSelect",
      valueOptions: options,
      renderCell: () => {
        return <BacklogFieldCell value={new_dg_row[0]['material_type']} handle_change={handle_change_new_row_data}
          id={"material_type"} type='select' options={options} />;
      },
    },
    {
      "field": "product_id",
      headerName: "PRODUCT ID",
      flex: 1,
      // width: 200,
      editable: false,
      align: "center",
      headerAlign: "center",
      renderCell: () => {
        return <BacklogFieldCell value={new_dg_row[0]['product_id']} handle_change={handle_change_new_row_data} id={"product_id"} />;
      },
    },
    {
      "field": "product_name",
      headerName: "PRODUCT NAME",
      flex: 1,
      // width: 200,
      editable: false,
      align: "center",
      headerAlign: "center",
      renderCell: () => {
        return <BacklogFieldCell value={new_dg_row[0]['product_name']} handle_change={handle_change_new_row_data} id={"product_name"} />;
      },
    },
    {
      "field": "batch_number",
      headerName: "BATCH NUMBER",
      flex: 1,
      // width: 200,
      editable: false,
      align: "center",
      headerAlign: "center",
      renderCell: () => {
        return <BacklogFieldCell value={new_dg_row[0]['batch_number']} handle_change={handle_change_new_row_data} id={"batch_number"} />;
      },
    },
    {
      "field": "market",
      headerName: "MARKET",
      flex: 1,
      // width: 200,
      editable: false,
      align: "center",
      headerAlign: "center",
      renderCell: () => {
        return <BacklogFieldCell value={new_dg_row[0]['market']} handle_change={handle_change_new_row_data} id={"market"} />;
      },
    },
    {
      "field": "spec_id",
      headerName: "SPEC ID",
      flex: 1,
      // width: 200,
      editable: false,
      align: "center",
      headerAlign: "center",
      renderCell: () => {
        return <BacklogFieldCell value={new_dg_row[0]['spec_id']} handle_change={handle_change_new_row_data} id={"spec_id"} />;
      },
    },
    {
      "field": "stp_id",
      headerName: "STP ID",
      flex: 1,
      // width: 200,
      editable: false,
      align: "center",
      headerAlign: "center",
      renderCell: () => {
        return <BacklogFieldCell value={new_dg_row[0]['stp_id']} handle_change={handle_change_new_row_data} id={"stp_id"} />;
      },
    },
    {
      "field": "qc_receive_date",
      headerName: "QC RECEIVE DATE",
      // flex: 1,
      width: 200,
      editable: false,
      align: "center",
      headerAlign: "center",
      type: "dateTime",
      renderCell: (props) => {
        return <HomePageTimeDatePicker {...props} state_setter={set_new_dg_row} />;
      }
    },
    {
      "field": "add_row",
      "headerName": "",
      "editable": false,
      renderCell: () => {
        const handle_add = async () => {
          const row = new_dg_row[0];
          // const vals = Object.values(row);
          for (let key in row) {
            if (key !== "material_type" && !hidden_fields?.includes(key)) {
              const val = row[key];
              if (val === "" || val === null) {
                alert("Please enter all the fields before adding the Sample Status.");
                return;
              }
            }
          }

          row.material_type = row?.material_type || category;

          const response = await postSampleStatus({ ...row });
          if (response === true) {
            apiRef.current.updateRows([{ ...row }]);
            set_new_dg_row(prev => ([{
              ...prev[0],
              "material_type": "",
              "product_id": "",
              "product_name": "",
              "batch_number": "",
              "qc_receive_date": new Date(),
              "market": "",
              "spec_id": "",
              "stp_id": "",
              id: v4()
            }]));
            // alert("updated");
          }
          else {
            // alert("couldn't update due to some error at the backend.");
            alert(response);
          }
        };
        return <ContainedButton handleClick={handle_add}>Add</ContainedButton>;
      }
    }
  ];

  const [open_snackbar_with_message, set_open_snackbar_with_message] = useState({
    open: false,
    message: "",
    severity: "info"
  });

  const [sample_status_file, set_sample_status_file] = useState(null);
  const [batch_offering_file, set_batch_offering_file] = useState(null);
  const dispatch = useDispatch();

  const handle_sample_status_upload = async (uploaded_file) => {
    try {
      const data = new FormData();
      data.append("excel_file", uploaded_file);
      console.log([...data.entries()]);
      const response = await httpCommon.post(`/v1/qc/upload_backlog/${category}/`, data, {
        "headers": {
          "Content-Type": "multipart/form-data"
        }
      });
      const result = response.data;
      // console.log({ result });
      if (result.status === "error") {
        set_open_snackbar_with_message({
          message: result.message,
          open: true,
          severity: "error"
        });
      }
      else if (result.status === "success") {
        set_open_snackbar_with_message({
          message: `Data uploaded successfully! Loading the new ${category} data now`,
          open: true,
          severity: "success"
        });
        dispatch(load_intm_backlog_from_backend());
      }
    } catch (error) {
      console.log({ error });
      set_open_snackbar_with_message({
        open: true,
        severity: "error",
        message: error?.response?.data?.message,
      });
    }
  };
  const handle_batch_offering_upload = async (uploaded_file) => {
    try {
      const data = new FormData();
      data.append("excel_file", uploaded_file);
      console.log([...data.entries()]);
      // http://127.0.0.1:8080/v1/qc/upload_batch_offering/Raw
      const response = await httpCommon.post(`/v1/qc/upload_batch_offering/${category}/`, data, {
        "headers": {
          "Content-Type": "multipart/form-data"
        }
      });
      const result = response.data;
      // console.log({ result });
      if (result.status === "error") {
        set_open_snackbar_with_message({
          message: result.message,
          open: true,
          severity: "error"
        });
      }
      else if (result.status === "success") {
        set_open_snackbar_with_message({
          message: `Data uploaded successfully! Loading the new ${category} data now`,
          open: true,
          severity: "success"
        });
        dispatch(load_intm_backlog_from_backend());
      }
    } catch (error) {
      console.log({ error });
      set_open_snackbar_with_message({
        open: true,
        severity: "error",
        message: error?.response?.data?.message,
      });
    }
  };


  return (
    <div>
      <Box>
        <SnackbarWithMessage {...open_snackbar_with_message} onClose={() => {
          set_open_snackbar_with_message({
            open: false,
            message: "",
            severity: "info"
          });
        }} />
        <Box className="flex items-center gap-2">
          {/* Sample Status File Uploader */}
          <FileUploaderRipik file={sample_status_file} file_update_function={(uploaded_file) => {
            set_sample_status_file(uploaded_file);
            console.log(uploaded_file);
            handle_sample_status_upload(uploaded_file);
          }} upload_message={`Upload ${category === "CB" ? "In Process" : category} Sample Status File Here`} />

          {/* Batch Offering File Uploader */}
          <FileUploaderRipik file={batch_offering_file} file_update_function={(uploaded_file) => {
            set_batch_offering_file(uploaded_file);
            console.log(uploaded_file);
            handle_batch_offering_upload(uploaded_file);
          }} upload_message={`Upload ${category === "CB" ? "In Process" : category} Batch Offering File Here`} />
        </Box>
        <PaginatedDataGrid
          apiRef={apiRef}
          sx={{
            maxHeight: "550px"
          }}
          // sx={{
          //   "& .MuiDataGrid-row:hover": {
          //     // backgroundColor: "rgba(25,25,100,0.4)"
          //     // color: "red"
          //   }
          // }}
          initialState={{
            pinnedColumns: {
              right: [
                "sla_completion_date",
                // "within_target",
                "completion_date",
                "remark",
                // "reviewers_remark",
              ],
              left: ["batch_number", "product_name"]
            },
          }}
          columnVisibilityModel={hidden_fields?.reduce((acc, el) => ({
            ...acc,
            [el]: false
          }), {})}
          rows={table_data} columns={columns}
          getRowClassName={getRowClassName}
        />

      </Box>
      <Box mt={2}>
        <CustomDataGrid
          columns={new_dg_columns}
          rows={new_dg_row}
          hideFooter
          initialState={{
            pinnedColumns: {
              left: ["batch_number", "product_name"]
            }
          }}
          columnVisibilityModel={hidden_fields?.reduce((acc, el) => ({
            ...acc,
            [el]: false,
          }), {
            // material_type: false
          })}
        />
      </Box>
    </div>
  );
};

export default BacklogTable;